import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';

import RootContext from "./RootContext"
import Login from "./Login"
import { unregisterAllServiceWorkers } from './serviceWorkerRegistration';
import './styles/main.css';

const container = document.getElementById("mfb");
if (!container) {
  throw new Error('App mount node #mfb not found');
}

const root = createRoot(container);
root.render(
  <RootContext>
   <Login/>
  </RootContext>
);

unregisterAllServiceWorkers();
